export function initMenuTabs() {
    
    const $tabs = $(".menu-section .tabs-slider");
    const $tabsContent = $tabs.find(".tabs-content");
    const $button = $tabs.find(".tabs-nav button");
    const $pages = $tabs.find(".tabs-page");

    $button.on("click", function (evt) {
        evt.preventDefault();
        
        if ( !$(this).hasClass("active") ) {
            $button.each((i, it) => {
                $(it).removeClass("active");
                $(it).attr("aria-expanded", "false");
            });
            $(this).addClass("active");
            $(this).attr("aria-expanded", "true");

            const $page = $(`${$(this).attr("href")}`);
            $tabsContent.addClass("animate");
            setTimeout(() => {
                $pages.removeClass("show");
                $page.addClass("show");
                $tabsContent.removeClass("animate");
            }, 300);
        }
    });

    $(".locations button").each(function(idx){
        var _id = $( this ).attr('data-name');
        document.querySelector( 'button[data-name="'+_id+'"]').addEventListener("keyup", function(event) {
            // Number 13 is the "Enter" key on the keyboard
            if (event.keyCode === 13) {
                event.preventDefault();
                var _name = $(this).attr('data-name');
                $('li[aria-controls="'+_name+'-1"]').attr('aria-selected', 'true');
                $('section[data-location="'+_name+'"] address a').focus();
            }
            if (event.keyCode === 9) {
                event.preventDefault();
                $(".locations li").removeClass('focus');
                $(this).parent().addClass('focus');
            }
        });
    });

    window.addEventListener("DOMContentLoaded", () => {
        const tabs = document.querySelectorAll('[role="tab"]');
    const tabList = document.querySelector('[role="tablist"]');

    // Add a click event handler to each tab
    tabs.forEach(tab => {
        tab.addEventListener("click", changeTabs);
});

    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;

    tabList.addEventListener("keydown", e => {
        // Move right
        if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute("tabindex", -1);
        if (e.keyCode === 39) {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= tabs.length) {
                tabFocus = 0;
            }
            // Move left
        } else if (e.keyCode === 37) {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
                tabFocus = tabs.length - 1;
            }
        }

        tabs[tabFocus].setAttribute("tabindex", 0);
        tabs[tabFocus].focus();
    }
});
});

    function changeTabs(e) {/*
        const target = e.target;
        const parent = target.parentNode;
        const grandparent = parent.parentNode;

        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach(t => t.setAttribute("aria-selected", false));

        // Set this tab as selected
        target.setAttribute("aria-selected", true);


        // Hide all tab panels
        grandparent
            .querySelectorAll('[role="tabpanel"]')
            .forEach(p => p.setAttribute("hidden", true));

        // Tab button
        var _ariaControls = target.getAttribute("aria-controls");
        console.log(target);
        var _tabButton = document.getElementById(_ariaControls);
        if(_tabButton.hasAttribute("hidden")) {
            _tabButton.removeAttribute("hidden");
        }*/
    }
/*
    $(".locations button").each(function(idx){
        var _id = $( this ).attr('data-name');
        document.querySelector( 'button[data-name="'+_id+'"]').addEventListener("keyup", function(event) {
            // Number 13 is the "Enter" key on the keyboard
            if (event.keyCode === 13) {
                event.preventDefault();
                var _id = $(this).text() ;
                document.getElementById(_id + "-5").focus();
            }
        });
    });*/

    $('.tabs-nav div[role="tablist"] button').each(function(idx){
        var _aria_controls    = $( this ).attr('aria-controls');
        document.querySelector('button[aria-controls="' + _aria_controls + '"]').addEventListener("keyup", function(event) {
            // Number 9 is the "Tab" key on the keyboard
            if (event.keyCode === 9) {
                event.preventDefault();
                $(this).focus();
                $(this).trigger('click');
            }
        });
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/menu-section-tabs.js